(function () {
  const selector = '[data-bodycare-marquee]';

  function makeClone(source) {
    const clone = source.cloneNode(true);
    clone.removeAttribute('data-bodycare-marquee-source');
    clone.setAttribute('data-bodycare-clone', '');
    clone.setAttribute('aria-hidden', 'true');
    clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
      element.setAttribute('tabindex', '-1');
    });
    clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
    clone.querySelectorAll('img').forEach((image) => {
      image.loading = 'lazy';
      image.removeAttribute('fetchpriority');
    });
    return clone;
  }

  function sizeMarquee(marquee) {
    const container = marquee.querySelector('.scrolling-banner__items-container');
    const source = marquee.querySelector('[data-bodycare-marquee-source]');
    if (!container || !source || !source.scrollWidth || !container.clientWidth) return;

    container.querySelectorAll('[data-bodycare-clone]').forEach((clone) => clone.remove());

    const targetWidth = container.clientWidth * 2;
    const groupWidth = source.scrollWidth;
    const existingGroups = container.querySelectorAll('.scrolling-banner__items').length;
    const requiredGroups = Math.min(8, Math.max(2, Math.ceil(targetWidth / groupWidth) + 1));

    for (let index = existingGroups; index < requiredGroups; index += 1) {
      container.appendChild(makeClone(source));
    }
  }

  function init(root = document) {
    const marquees = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector) || [];
    marquees.forEach((marquee) => {
      if (marquee.dataset.bodycareMarqueeReady === 'true') return;
      marquee.dataset.bodycareMarqueeReady = 'true';
      sizeMarquee(marquee);

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(() => sizeMarquee(marquee));
        observer.observe(marquee);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('bodycare:content:loaded', (event) => init(event.target));
})();
